export default __webpack_public_path__ + "static/1-b60ef0cf940265a1adc2648a8b2a6cc7.jpg";